import { render, staticRenderFns } from "./EditBannerPopUp.vue?vue&type=template&id=c95ebffa&scoped=true"
import script from "./EditBannerPopUp.vue?vue&type=script&lang=js"
export * from "./EditBannerPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditBannerPopUp.vue?vue&type=style&index=0&id=c95ebffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ebffa",
  null
  
)

export default component.exports